import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      attrs: { "offset-y": "", left: "", transition: "slide-y-transition" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(VBtn, _vm._g({ attrs: { icon: "" } }, on), [
                _vm._v(
                  _vm._s(_vm.currency.currencySymbol + " " + _vm.currency.label)
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VList,
        { attrs: { dense: "", nav: "" } },
        _vm._l(_vm.currencies, function (item) {
          return _c(
            VListItem,
            {
              key: item.label,
              on: {
                click: function ($event) {
                  return _vm.setCurrency(item)
                },
              },
            },
            [
              _c(VListItemTitle, [
                _vm._v(_vm._s(item.currencySymbol + " " + item.label)),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }